import moment from 'moment';

import { TimeValueType } from './TimePicker/TimePickerInput';

export const getFormatPattern = (conformedValue: string) => {
  const yearPart = conformedValue.substring(0, 4);
  const monthPart = conformedValue.substring(5, 7).replace(/[\s-]+/g, '');
  const dayPart = conformedValue.substring(8, 10).replace(/[\s-]+/g, '');

  const year = parseInt(yearPart);
  const month = parseInt(monthPart);
  const day = parseInt(dayPart);
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const isNonMonth = month === 0 || month > 12;

  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) daysInMonth[1] = 29;

  if (monthPart.length === 2 && isNonMonth) return false;

  if (dayPart.length === 2) {
    if (day === 0) return false;
    if (day > daysInMonth[month - 1]) return `${conformedValue.substring(0, 8)}${daysInMonth[month - 1]}`;
  }

  return conformedValue;
};

export const MINUTE_STEP = 5;

type IsTimeValueDisabledProps = {
  value: number;
  valueType: TimeValueType;
  disabledBeforeTime?: Date;
  selectedHour?: number | null;
};

export const isTimeValueDisabled = ({
  value,
  valueType,
  disabledBeforeTime,
  selectedHour,
}: IsTimeValueDisabledProps) => {
  if (!disabledBeforeTime) return false;

  const isHourInput = valueType === TimeValueType.HOUR;
  const disabledTime = moment(disabledBeforeTime);
  const disabledHour = disabledTime.hour();
  const disabledMinute = disabledTime.minute();

  if (isHourInput) {
    if (value < disabledHour) return true;
    if (value === disabledHour) {
      const nextValidMinute = Math.ceil(disabledMinute / MINUTE_STEP) * MINUTE_STEP;
      if (nextValidMinute >= 60) return true;
    }
  } else if (selectedHour != null && selectedHour < disabledHour) {
    return true;
  } else if (selectedHour === disabledHour) {
    const minimumValidMinute = Math.ceil(disabledMinute / MINUTE_STEP) * MINUTE_STEP;
    return value < minimumValidMinute;
  }

  return false;
};
